import WasteChecksheetMainBox from './components/WasteChecksheetMainBox';
import WasteCheckSheetTitleArea from './components/WasteCheckSheetTitleArea';
import PageArea from '../../components/shared/PageArea';
import { WasteChecksheetDetailProvider } from './contexts/WasteChecksheetDetailContext';
import WasteCheckSheetDetailModals from './components/WasteCheckSheetDetailModals';

const WasteCheckSheetDetailsPage = () => {
  return (
    <WasteChecksheetDetailProvider>
      <PageArea>
        <WasteCheckSheetTitleArea />
        <WasteChecksheetMainBox />
        <WasteCheckSheetDetailModals />
      </PageArea>
    </WasteChecksheetDetailProvider>
  );
};

export default WasteCheckSheetDetailsPage;